import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo2.png";
import bgImage from "../assets/bgg.jpg";
import { FaLock, FaEye, FaEyeSlash, FaSpinner, FaCheckCircle } from "react-icons/fa";
import api from "../services/api";

export default function ResetPassword() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  const uid = params.get("uid");
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (!uid || !token) { setError("Invalid reset link. Please request a new one."); return; }

    setLoading(true);
    try {
      await api.post("/auth/verify-reset-code/", { uid, token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.error || "Reset failed. The link may have expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-cover bg-center" style={{ backgroundImage: `url(${bgImage})` }}>
      <main className="flex-grow flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md bg-white/95 p-8 rounded-2xl shadow-xl text-black">
          <div className="flex justify-center mb-5">
            <a href="/"><img src={logo} alt="UCH" className="h-12" /></a>
          </div>
          <h2 className="text-2xl font-bold text-center mb-2 text-gray-900">Set New Password</h2>
          <p className="text-sm text-gray-500 text-center mb-6">Enter and confirm your new password below.</p>

          {done ? (
            <div className="text-center space-y-4">
              <FaCheckCircle className="w-12 h-12 text-green-600 mx-auto" />
              <p className="text-green-700 font-semibold">Password reset successfully!</p>
              <button onClick={() => navigate("/login")}
                className="mt-3 w-full bg-green-700 text-white py-3 rounded-lg font-semibold hover:bg-green-800">
                Go to Login
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="relative">
                <FaLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input type={showPwd ? "text" : "password"} placeholder="New password" required minLength={8}
                  value={password} onChange={e => setPassword(e.target.value)}
                  className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm" />
                <button type="button" onClick={() => setShowPwd(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                  {showPwd ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <input type="password" placeholder="Confirm new password" required minLength={8}
                value={confirm} onChange={e => setConfirm(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm" />
              {error && <p className="text-red-600 text-sm">{error}</p>}
              <button type="submit" disabled={loading}
                className="w-full bg-green-700 hover:bg-green-800 text-white py-3 rounded-lg font-semibold disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                {loading ? <><FaSpinner className="animate-spin" /> Resetting...</> : "Reset Password"}
              </button>
              <a href="/login" className="block text-center text-sm text-gray-500 hover:underline">← Back to Login</a>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
